export const ADD_ATTRIBUTE_DETAILS = "ADD_ATTRIBUTE_DETAILS";
export const FETCH_ATTRIBUTE_LIST = "FETCH_ATTRIBUTE_LIST";
export const EDIT_CATEGORY_ATTRIBUTE_DETAILS =
  "EDIT_CATEGORY_ATTRIBUTE_DETAILS";
export const UPDATE_ATTRIBUTE_DETAILS = "UPDATE_ATTRIBUTE_DETAILS";
export const DELETE_ATTRIBUTE_DETAILS = "DELETE_ATTRIBUTE_DETAILS";
export const FETCH_CATEGORY_DROPDOWN_LIST = "FETCH_CATEGORY_DROPDOWN_LIST";
